// Standalone "short" onboarding funnel: a cut-down (19-page) version of the
// baseline onboarding funnel. Like the trial funnel it has no landing page and
// starts directly with the language question at its 'question-language' entry.
// It reuses the existing baseline page components verbatim (no new components,
// no new translation keys) and simply runs a shorter, fixed sequence before
// handing off to the shared sign-up flow. This funnel is completely independent
// of the /onboarding A/B wiring.

import navigateToNextShortOnboardingPageAction from '@/actions/navigateToNextShortOnboardingPageAction'
import AgePage from '@/pages/baseline/onboarding/AgePage'
import CraftingProgressPage from '@/pages/baseline/onboarding/CraftingProgressPage'
import DreamScenarioPage from '@/pages/baseline/onboarding/DreamScenarioPage'
import FinalCommitmentPage from '@/pages/baseline/onboarding/FinalCommitmentPage'
import GoalsQuestionPage from '@/pages/baseline/onboarding/GoalsQuestionPage'
import GoalsTimelinePage from '@/pages/baseline/onboarding/GoalsTimelinePage'
import IdentityShiftPage from '@/pages/baseline/onboarding/IdentityShiftPage'
import LanguageQuestionPage from '@/pages/baseline/onboarding/LanguageQuestionPage'
import LearningContextPage from '@/pages/baseline/onboarding/LearningContextPage'
import LearningProfileSummaryPage from '@/pages/baseline/onboarding/LearningProfileSummaryPage'
import LevelQuestionPage from '@/pages/baseline/onboarding/LevelQuestionPage'
import MariaTestimonialPage from '@/pages/baseline/onboarding/MariaTestimonialPage'
import MistakesQuestionPage from '@/pages/baseline/onboarding/MistakesQuestionPage'
import PersonalizedPlanPreviewPage from '@/pages/baseline/onboarding/PersonalizedPlanPreviewPage'
import SelfEfficacyPage from '@/pages/baseline/onboarding/SelfEfficacyPage'
import SubscriptionCountPage from '@/pages/baseline/onboarding/SubscriptionCountPage'
import TimeQuestionPage from '@/pages/baseline/onboarding/TimeQuestionPage'
import TopicsQuestionPage from '@/pages/baseline/onboarding/TopicsQuestionPage'
import WhyQuestionPage from '@/pages/baseline/onboarding/WhyQuestionPage'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'

const shortOnboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      // Entry: like the trial funnel there is no landing page; the language
      // question owns the ad-entry URL at 'question-language'.
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <LanguageQuestionPage />,
        path: 'question-language',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <AgePage />,
        path: 'age',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <LevelQuestionPage />,
        path: 'level-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <LearningContextPage />,
        path: 'learning-context',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <WhyQuestionPage />,
        path: 'why-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <DreamScenarioPage />,
        path: 'dream-scenario',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <GoalsQuestionPage />,
        path: 'goals-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <GoalsTimelinePage />,
        path: 'goals-timeline',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <TimeQuestionPage />,
        path: 'time-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <MistakesQuestionPage />,
        path: 'mistakes-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <SelfEfficacyPage />,
        path: 'self-efficacy',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <TopicsQuestionPage />,
        path: 'topics-question',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <MariaTestimonialPage />,
        path: 'maria-testimonial',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <LearningProfileSummaryPage />,
        path: 'learning-profile-summary',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <PersonalizedPlanPreviewPage />,
        path: 'personalized-plan-preview',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <IdentityShiftPage />,
        path: 'identity-shift',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <FinalCommitmentPage />,
        path: 'final-commitment',
      },
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <SubscriptionCountPage />,
        path: 'subscription-count',
      },
      // Last step: auto-advances, and being last the action redirects to
      // /sign-up/company.
      {
        action: navigateToNextShortOnboardingPageAction,
        element: <CraftingProgressPage />,
        path: 'crafting-progress',
      },
    ],
  },
]

export default shortOnboardingRoutes
